import { endOfDay, getISOWeek, isSunday, startOfDay } from "date-fns";
import React from "react";
import { IAttentionDay, KindOfAttentionDay } from '../../domain/attentiondays/IAttentionDay';
import { dateAdd, dateFormat, dateOverlap, dayMs } from "../../helpers/dateHelpers";
import { MonthDay } from "./MonthDay";

interface AbsenceMonthTableHeaderProps {
    month: Date;
    colWidth: string;
    daysOfMonth: Date[]
    allAttentionDays: IAttentionDay[];
}
export class AbsenceMonthTableHeader extends React.Component<AbsenceMonthTableHeaderProps> {

    getSpecialDaysForDate(date: Date) {
        return this.props.allAttentionDays ? this.props.allAttentionDays.filter(x => dateOverlap(startOfDay(x.start), endOfDay(x.end), startOfDay(date), endOfDay(date)) > 0) : [];
    }

    render() {
        const dates: JSX.Element[] = [];
        this.props.daysOfMonth.forEach(d => {
            const attentionDaysForDate = this.getSpecialDaysForDate(d);
            attentionDaysForDate.sort((a, b) => a.kind - b.kind);
            const classes = [];
            if (attentionDaysForDate.length > 0) {
                if (attentionDaysForDate.some(x => x.kind === KindOfAttentionDay.AttentionDay)) {
                    classes.push('is-special-day');
                } else if (attentionDaysForDate.some(x => x.kind === KindOfAttentionDay.Holiday)) {
                    classes.push('is-holiday');
                }
            };
            const attentionDays = attentionDaysForDate.map(a => <span key={`${a.id}`}>{a.name}<br /></span>)
            dates.push(<MonthDay key={`header-${d.toISOString()}`} date={d} width={this.props.colWidth} classes={classes} >
                <div className="a-tooltip ">
                    {isSunday(d) ? `Wk ${getISOWeek(dateAdd(d, 1 * dayMs))}` : ""}
                    <br />
                    {dateFormat(d, "iii")}
                    <br />
                    {d.getDate()}
                    {attentionDaysForDate.length > 0 ? <span className="tooltiptext left">{attentionDays}</span> : ""}
                </div>
            </MonthDay>)
        });

        return (<thead><tr>
            <th className="dagcellHeader group-header" style={{ width: "20%" }}>&nbsp;</th>
            <th className="dagcellHeader group-header center" colSpan={dates.length}>{dateFormat(this.props.month, "MMMM")}</th>
        </tr>
            <tr>
                <td className="dagcellHeader employee-name" style={{ width: "20%" }}>Werknemer</td>
                {dates}
            </tr>
        </thead>);
    }
}
